import { Box, Flex, Image, Text } from "@chakra-ui/react";

import { useEffect, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../components/common/DashboardHeader";
import Loading from "../../components/common/Loading";
import no_image from "../../img/bookpic.jpg";
import empty from "../../img/emptystate1.svg";
import warning from "../../img/warning.svg";
import { IUser } from "../../models/auth.model";
import { IGetEnrolment } from "../../models/course-enrolment.model";
import { getLocalUserProfile } from "../../services/auth.service";
import courseEnrolmentService from "../../services/course-enrolment.service";
import courseRoutes from "../courses/courseRoutes";

const MyApplication = () => {
  const [user, setUser] = useState<IUser | null>();

  const navigate = useNavigate();
  const [availableCourses, setAvailableCourses] = useState<IGetEnrolment[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = getLocalUserProfile();
    if (user) {
      setUser(user);
      courseEnrolmentService
        .getEnroledCourses(user.id.toString())
        .then((response) => {
          const newlyEnrolledCourse = response.data.filter(
            (course) => course.status == 1
          );
          setAvailableCourses(newlyEnrolledCourse);

          setLoading(false);
        })
        .catch((err) => err);
    }
  }, []);

  const viewCourse = async (course_id: string) => {
    navigate(courseRoutes.mycourselink(course_id));
  };

  return (
    <>
      <DashboardHeader />
      <Box bg="#F9F8F8" minHeight="100vh" height="auto" pt="20px" pb="2rem" width={"100%"}>
        <Box
          bg="white"
          borderTopRadius="5px"
          fontWeight="700"
          fontSize="20px"
          shadow="md"
          px="2rem"
          color="#353535"
          width={["90%", "90%", "70%", "60%"]}
          mx="auto"
          pt="20px"
          pb="15px"
          mt="20px"
          mb="15px"
        
        >
          My Application(s)
        </Box>

        {loading ? (
          <Loading />
        ) : (
          <>
            {availableCourses.map((each, index) => (
              <Flex
                key={index}
                bg="white"
                width={["90%", "90%", "70%", "60%"]}
                justifyContent={"center"}
                mb="1.8rem"
                mt="10px"
                mx="auto"
                pt="10px"
                pb="0.5rem"
                boxShadow="base"
                onClick={() => viewCourse(each.course.uuid)}
                cursor="pointer"
              >
                <Box
                  p="8px"
                  bg="white"
                  mb="25px"
                  width={"100%"}
                >
                  <Box
                    mx="auto"
                    width="87%"
                    bg="white"
                    pb="8px"
                    pt="10px"
                    mb="24px"
                    borderBottom="2px solid"
                    borderColor="gray.200"
                    display={"flex"}
                    alignItems={"center"}
                  >
                    <Image src={warning} />
                    <Text
                      ml="10px"
                      fontSize="16px"
                      color="#F79E1B"
                      fontWeight="500"
                    >
                      Application pending approval
                    </Text>
                  </Box>
                  <Flex
                    mx="auto"
                    width="87%"
                    bg="white"
                    pb="12px"
                    pt="15px"
                    justifyContent="space-between"
                    flexDirection={["column", "column", "row", "row"]}
                  >
                    <Box width={["100%", "47%"]}>
                      <Image
                        objectFit="fill"
                        height="190px"
                        bgPosition="center"
                        width="100%"
                        src={
                          each.course.cover_image
                            ? each.course.cover_image
                            : no_image
                        }
                      />
                    </Box>
                    <Box width={["100%", "47%"]}>
                      <Text
                        color="black"
                        fontSize="22px"
                        textTransform="capitalize"
                        fontWeight="600"
                        mb="21px"
                      >
                        {each.course.name.toLowerCase()}
                      </Text>
                      <Text
                        color="#9E9E9E"
                        fontSize="14px"
                        fontWeight="400"
                        mb="21px"
                      >
                        {each.course.description
                          ? each.course.description.substring(0, 200)
                          : "nil"}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              </Flex>
            ))}

            {availableCourses && availableCourses.length === 0 && (
              <Box
                bg="white"
                width={["90%", "90%", "70%", "60%"]}
                mb="10px"
                mx="auto"
                pt="40px"
                pb="70px"
                rounded="lg"
                shadow="sm"
              >
                <Box>
                  <Box mx="auto" width="100px" height="150px">
                    <Image src={empty} />
                  </Box>
                  <Text
                    textAlign="center"
                    fontWeight="600"
                    fontSize="24px"
                    color="#353535"
                  >
                    No Applications
                  </Text>
                  <Text color="#353535" textAlign="center" fontSize="14px">
                    You don't have an application yet
                  </Text>
                </Box>
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default MyApplication;
